/* Excella Quick Buy enhancements v6 — centered compact layout, wider window,
   variant block centered with the price. Forced via inline !important. */
(function(){
  'use strict';

  function money(cents){
    try { if (window.Shopify && Shopify.formatMoney) return Shopify.formatMoney(cents, window.money_format || '${{amount}}'); } catch(e){}
    return '$' + (Number(cents)/100).toFixed(2);
  }
  function pdata($form){
    var key = ($form.attr('id') || '').replace('AddToCartForm--','');
    var el = document.getElementById('product-json-' + key);
    if(!el) return null;
    try { return JSON.parse(el.textContent || el.innerHTML); } catch(e){ return null; }
  }
  function vById(prod, id){
    id = String(id);
    for (var i=0;i<prod.variants.length;i++){ if(String(prod.variants[i].id)===id) return prod.variants[i]; }
    return null;
  }
  function currentV(prod, $form){
    var v = vById(prod, $form.find('select[name=id]').val());
    if(v) return v;
    for (var i=0;i<prod.variants.length;i++){ if(prod.variants[i].available) return prod.variants[i]; }
    return prod.variants[0];
  }
  function hasNoRealVariants(prod){
    if(!prod || !prod.variants || prod.variants.length !== 1) return false;
    var t = String(prod.variants[0].title || '').toLowerCase();
    if(t === 'default title' || t === '' ) return true;
    var o = (prod.options && prod.options.length === 1) ? prod.options[0] : null;
    if(o && typeof o === 'object') o = o.name;
    return String(o || '').toLowerCase() === 'title';
  }
  function imp(el, prop, val){ if(el && el.style) el.style.setProperty(prop, val, 'important'); }
  function hideAll($els){ $els.each(function(){ imp(this,'display','none'); }); }
  function setPrice($form, cents){
    var $pv = $form.closest('.quickview-form');
    var $inner = ($pv.length ? $pv : $form).find('.price--inner').first();
    if(!$inner.length) return;
    var $h = $inner.find('.header').first();
    var hHtml = $h.length ? $h.prop('outerHTML') : '';
    $inner.html(hHtml + '<span class="qbuy-price money" data-qbuy-price>' + money(cents) + '</span>');
    imp($inner[0],'text-align','center');
  }
  function linkTitle($pv, prod){
    if(!prod || !prod.url) return;
    var $h1 = $pv.find('h1').first();
    if(!$h1.length || $h1.find('a').length) return;
    var a = document.createElement('a');
    a.className = 'qbuy-title-link';
    a.href = prod.url;
    a.textContent = $h1.text();
    $h1.empty().append(a);
  }
  function relayout($pv, prod){
    var $form = $pv.find('form').first();
    if(!$form.length) return;
    var form = $form[0];

    hideAll($pv.find('.product--images'));
    var ps = $pv.find('.product-single')[0];
    if(ps){ imp(ps,'display','block'); imp(ps,'visibility','visible'); imp(ps,'margin','0'); }
    var det = $pv.find('.pr35')[0];
    if(det){ imp(det,'width','100%'); imp(det,'max-width','100%'); imp(det,'float','none'); imp(det,'padding','0'); imp(det,'text-align','center'); }
    var h1 = $pv.find('h1')[0];
    if(h1){ imp(h1,'text-align','center'); imp(h1,'width','100%'); imp(h1,'font-size','20px'); imp(h1,'line-height','1.25'); imp(h1,'margin','0 0 10px'); }
    var mc = document.querySelector('#quick-view .modal-content');
    if(mc){ imp(mc,'max-width','715px'); imp(mc,'max-height','90vh'); imp(mc,'overflow-y','auto'); imp(mc,'overflow-x','hidden'); imp(mc,'transform','none'); imp(mc,'top','auto'); imp(mc,'margin','0 auto'); imp(mc,'position','relative'); }

    if(form.getAttribute('data-ex-laid')) return;
    form.setAttribute('data-ex-laid','1');

    var wide = window.innerWidth >= 768;
    var top = document.createElement('div');
    top.className = 'qbuy-top';

    var src = prod && (prod.featured_image || (prod.images && prod.images[0]));
    if(src){
      if(src.indexOf('//') === 0) src = 'https:' + src;
      src = src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=700';
      var hw = document.createElement('div');
      hw.className = 'qbuy-hero-wrap';
      hw.innerHTML = '<img class="qbuy-hero" src="' + src + '" alt="">';
      top.appendChild(hw);
    }

    var info = document.createElement('div');
    info.className = 'qbuy-info';
    var price = form.querySelector('.product--option.price');
    if(price) info.appendChild(price);
    var swatches = form.querySelectorAll('.product--option.swatch');
    for(var i=0;i<swatches.length;i++) info.appendChild(swatches[i]);
    var sel = form.querySelector('select[name=id]');
    if(sel) info.appendChild(sel);
    top.appendChild(info);

    form.insertBefore(top, form.firstChild);

    var atc = form.querySelector('.addtocart--button');
    if(atc) form.appendChild(atc);

    imp(form,'display','block');
    imp(top,'display','flex'); imp(top,'align-items','center'); imp(top,'justify-content','center');
    imp(top,'gap','18px'); imp(top,'flex-wrap', wide ? 'nowrap' : 'wrap'); imp(top,'margin','0 0 8px');
    var hwEl = top.querySelector('.qbuy-hero-wrap');
    if(hwEl){ imp(hwEl,'flex', wide ? '0 0 44%' : '0 0 100%'); imp(hwEl,'max-width', wide ? '44%' : '100%'); }
    var heroImg = top.querySelector('.qbuy-hero');
    if(heroImg){ imp(heroImg,'display','block'); imp(heroImg,'width','100%'); imp(heroImg,'max-width','100%'); imp(heroImg,'max-height','230px'); imp(heroImg,'object-fit','contain'); imp(heroImg,'margin','0 auto'); imp(heroImg,'border-radius','8px'); }
    imp(info,'flex','1 1 auto'); imp(info,'min-width','0'); imp(info,'text-align','center');

    // Center the price + variant block within the info column
    if(price){ imp(price,'text-align','center'); imp(price,'width','100%'); imp(price,'float','none'); imp(price,'margin','0 auto'); }
    var pin = info.querySelector('.price--inner'); if(pin){ imp(pin,'text-align','center'); imp(pin,'width','100%'); }
    for(var s=0;s<swatches.length;s++){
      imp(swatches[s],'text-align','center'); imp(swatches[s],'width','100%'); imp(swatches[s],'float','none'); imp(swatches[s],'margin','10px auto 0');
      var sh = swatches[s].querySelector('.header'); if(sh){ imp(sh,'text-align','center'); imp(sh,'width','100%'); }
    }

    if(atc){
      imp(atc,'display','block'); imp(atc,'width','100%'); imp(atc,'text-align','center'); imp(atc,'margin','10px 0 0');
      var gItems = atc.querySelectorAll('.grid__item');
      for(var g=0;g<gItems.length;g++){ imp(gItems[g],'width','100%'); imp(gItems[g],'max-width','100%'); imp(gItems[g],'float','none'); imp(gItems[g],'display','block'); imp(gItems[g],'padding','0'); imp(gItems[g],'text-align','center'); }
      var heads = atc.querySelectorAll('.header');
      for(var h=0;h<heads.length;h++){ if(!(heads[h].textContent || '').trim()) imp(heads[h],'display','none'); }
    }
    var qtyRow = form.querySelector('.ex-qty-row');
    if(qtyRow){ imp(qtyRow,'display','inline-flex'); imp(qtyRow,'align-items','center'); imp(qtyRow,'justify-content','center'); imp(qtyRow,'margin','2px auto 6px'); }
    var qbtns = form.querySelectorAll('.ex-qty-btn');
    for(var b=0;b<qbtns.length;b++){ imp(qbtns[b],'width','30px'); imp(qbtns[b],'height','30px'); imp(qbtns[b],'padding','0'); imp(qbtns[b],'font-size','15px'); imp(qbtns[b],'line-height','1'); }
    var qnum = form.querySelector('.ex-qty-num'); if(qnum){ imp(qnum,'min-width','30px'); imp(qnum,'font-size','14px'); }
    var atcBtn = form.querySelector('.AddToCart');
    if(atcBtn){ imp(atcBtn,'display','inline-block'); imp(atcBtn,'width','auto'); imp(atcBtn,'min-width','240px'); imp(atcBtn,'margin','0 auto'); }
  }
  function process($pv){
    if(!$pv || !$pv.length || $pv.data('exQb')) return;
    $pv.data('exQb', true);
    var $form = $pv.find('form').first();
    if(!$form.length) return;
    var prod = pdata($form);
    var $select = $pv.find('select[name=id]').addClass('qbuy-select');
    if(hasNoRealVariants(prod)){
      $pv.addClass('qbuy-no-variants');
      $select.each(function(){ imp(this,'display','none'); });
    } else if($pv.find('.product--option.swatch').length){
      $pv.addClass('qbuy-has-swatch');
      $select.each(function(){ imp(this,'display','none'); });
    } else if(prod && prod.variants && prod.variants.length > 1){
      if(!$select.prev('.qbuy-variants__label').length){
        $select.before('<div class="qbuy-variants__label">Choose your option</div>');
      }
    }
    linkTitle($pv, prod);
    try { relayout($pv, prod); } catch(e){}
    setTimeout(function(){ try { relayout($pv, prod); } catch(e){} }, 400);
    setTimeout(function(){ try { relayout($pv, prod); } catch(e){} }, 1000);
    if(prod){
      setPrice($form, currentV(prod, $form).price);
      setTimeout(function(){ setPrice($form, currentV(prod, $form).price); }, 450);
      setTimeout(function(){ setPrice($form, currentV(prod, $form).price); }, 1100);
    }
  }
  function scan(root){
    var $ = window.jQuery; if(!$) return;
    $(root).find('.quickview-form').each(function(){ process($(this)); });
  }
  function init(){
    var $ = window.jQuery; if(!$){ return setTimeout(init, 200); }
    var qv = document.getElementById('quick-view');
    if(qv && window.MutationObserver){
      new MutationObserver(function(m){
        for(var i=0;i<m.length;i++){ if(m[i].addedNodes && m[i].addedNodes.length){ scan(qv); break; } }
      }).observe(qv, { childList:true, subtree:true });
    }
    $(document).on('click', '.quick-shop', function(){
      setTimeout(function(){ scan(document); }, 250);
      setTimeout(function(){ scan(document); }, 700);
      setTimeout(function(){ scan(document); }, 1400);
    });
    $(document).on('change', '.quickview-form .swatch-element input[type=radio]', function(){
      var $form = $(this).closest('form'), $pv = $(this).closest('.quickview-form');
      var chosen = [];
      $pv.find('.product--option.swatch').each(function(){
        var idx = parseInt($(this).attr('data-option-index'),10) || 0;
        chosen[idx] = $(this).find('input[type=radio]:checked').val();
      });
      var prod = pdata($form); if(!prod) return;
      var match = null;
      for(var i=0;i<prod.variants.length;i++){
        var v = prod.variants[i], ok = true;
        for(var o=0;o<chosen.length;o++){ if(chosen[o]!=null && v.options[o]!==chosen[o]){ ok=false; break; } }
        if(ok){ match = v; break; }
      }
      if(match){ $form.find('select[name=id]').val(match.id).trigger('change'); setPrice($form, match.price); }
    });
    $(document).on('change', '.quickview-form select[name=id]', function(){
      var $form = $(this).closest('form');
      var prod = pdata($form); if(!prod) return;
      var v = vById(prod, $(this).val());
      if(v) setPrice($form, v.price);
    });
  }
  if(document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', init); }
  else { init(); }
})();
